import { useState, useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  AdminPageHeader,
  // Button,
  // ButtonSize,
  // ButtonStyles,
  // ButtonTypes,
  // Modal,
  // Theme,
  TableWithSearchTemplate,
} from '../../../ui/components';
import { LoggerService } from '../../../ui/utils';
//import { useAdminToast } from '../../../ui/components/AdminToast/AdminToast';
import { useAPICall } from '../../../hooks';
import LocationService from '../../../sdk/services/locationService';
import getLocationListConfig, { dataSearchOption } from './locationListConfig'; // Import the location configuration

export const AdminLocationList = () => {
  const { t } = useTranslation();
  //const navigate = useNavigate();
  const [selectedRowId, setSelectedRowId] = useState('');
  //const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);

  const apiCall = useAPICall();

  //const { adminToast } = useAdminToast();

  useEffect(() => {
    fetchLocationList();
  }, []);

  const fetchLocationList = async () => {
    try {
      const response = await apiCall(LocationService.getLocationList);
      setData(response?.data?.data ?? []);
    } catch (error) {
      LoggerService.log('Failed to retrieve location list', error);
    }
  };

  // const onEdit = (id: string) => {
  //   navigate(`/admin/location-setup/edit?=${id}`);
  // };

  // const onClick = (id: string) => {
  //   //to show pop up modal
  //   setSelectedRowId(id);
  //   setShowDelete(true);
  // };

  // const buttonConfig = [
  //   {
  //     title: t('admin.locationMaster.addlocation'),
  //     buttonStyle: ButtonStyles.SOLID,
  //     onClick: () => {
  //       navigate(`/admin/location-setup/edit?=new`);
  //     },
  //   },
  // ];

  // const onDeleteAction = async () => {
  //   try {
  //     const response = await apiCall(LocationService.deleteLocation, `${selectedRowId}`);

  //     if (response?.status === 200) {
  //       // Assuming the server responds with success status
  //       LoggerService.log('Location deleted successfully');
  //       adminToast({
  //         message: 'Location deleted successfully',
  //         theme: Theme.SUCCESS,
  //       });
  //       fetchLocationList();
  //     } else {
  //       LoggerService.log('Failed to delete location');
  //     }
  //   } catch (error) {
  //     LoggerService.log('Error deleting location', error);
  //   } finally {
  //     // Close the modal whether the deletion was successful or not
  //     setShowDelete(false);
  //   }
  // };

  // const deletePrompt = (
  //   <>
  //     {showDelete && (
  //       <Modal
  //         primaryButtonLabel={''}
  //         headline={`${t('admin.locationMaster.deleteLocation')}`}
  //         closeIcon={false}
  //         containerWidth={'460px'}
  //         primaryButton={
  //           <Button
  //             title={t('admin.locationMaster.confirm')}
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               onDeleteAction();
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.SOLID}
  //             data-testid="test-add-button-popup"
  //           />
  //         }
  //         secondaryButton={
  //           <Button
  //             title={t('admin.locationMaster.cancel')}
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               setShowDelete(false);
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.OUTLINE}
  //             theme={Theme.BLACK}
  //             data-testid="test-cancel-button-popup-delete-modal"
  //           />
  //         }
  //       />
  //     )}
  //   </>
  // );

  return (
    <div>
      <AdminPageHeader title={t('admin.locationMaster.title')} />
      <TableWithSearchTemplate
        dataSource={data} // Replace with the actual data
        onReset={() => void 0}
        searchByStrip
        getColumns={getLocationListConfig} // Use the location configuration
        data={dataSearchOption}
        rowKey="recId"
        selected={selectedRowId}
        //cb={{ onEdit, onClick }}
        onRowClick={row => {
          setSelectedRowId(row.recId);
        }}
      />
      {/* {deletePrompt} */}
    </div>
  );
};
